export default __webpack_public_path__ + "static/media/avto.7aa3596c.png";